import { useContext, useEffect } from 'react';

import { PKR_INITIAL_STATE, PokerContext } from '@swf/poker';

const useResetStoreOnUnmount = () => {
  const {
    state: { updateState }
  } = useContext(PokerContext);

  const { clubs, games } = PKR_INITIAL_STATE;

  // Reset to initial state on unmount
  useEffect(
    () => () => {
      updateState('clubs', clubs);
      updateState('games', games);
    },
    [updateState, clubs, games]
  );
};

export default useResetStoreOnUnmount;
